import React from 'react'
import bandPhoto from '../images/DSC08210.jpg'
import possumArt from '../images/possum.png'
import { Helmet } from 'react-helmet-async'

const Bio = () => {
  return (
    <div>
      <Helmet>
        <title>The Asheville Mountain Boys - Bio</title>
        <meta
          name="description"
          content="Learn more about The Asheville Mountain Boys."
        />
        <link rel="canonical" href="/bio" />
      </Helmet>
      <header className="h-screen/3 overflow-hidden pt-20 md:pt-0 ">
        <div className="relative">
          <img
            src={bandPhoto}
            alt="The Asheville Mountain Boys photo"
            className="w-full h-[35vh] md:h-[50vh] object-cover object-[50%_10%] opacity-50"
          />
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <h1 className="text-gray-800 text-2xl md:text-3xl tracking-widest">
              Bio
            </h1>
          </div>
        </div>
      </header>
      <main className="flex bg-slate-50">
        <div className="items-center  mx-auto ">
          <p className=" max-w-4xl p-8">
            By their name, you know where they are from, and by their sound, you
            know what they are about. The Asheville Mountain Boys are on a
            mission to capture not just the style but the spirit of traditional
            bluegrass. Asheville, NC has long been known for great music and its
            roots in bluegrass go back to the founding of the genre (Bill
            Monroe’s first broadcast performance as the Bluegrass Boys was at
            Asheville radio station WWNC in 1938) A group that firmly stakes its
            claim to the tradition of the music from the area, The Asheville
            Mountain Boys spring onto the scene with a thought, ”What happened
            to bluegrass?” It’s not a disparaging one that condemns current
            styles in the genre but rather asks, “Why do we love this music in
            the first place” and answers with an approach that is true to the
            originators of the genre in the sense of both style and philosophy.
            Bluegrass is raw emotion, excitement, drive, and authenticity. It is
            not sanitized or compromised but a reflection of the lives of those
            who play it. It’s storytelling that follows a throughline of
            tradition.
          </p>
          <div className="flex justify-center items-center mx-auto"></div>
        </div>
      </main>
    </div>
  )
}

export default Bio
